import type { Dispatch } from '/business/shared/state/actions/types';

export type WhitelabelStep1AnswersConfig = {
  allAnswersRequired: boolean;
  minimumAnswersRequired: number | null;
};

export type WhitelabelConfig = {
  locales?: string[];
  defaultVariables?: Array<Record<string, string>>;
  reducePage?: {
    reductionsConfig: {
      minimumReductionPercentage: number | null;
    };
    hasAspirationalOffsetTarget?: boolean;
  };
  step1Answers?: WhitelabelStep1AnswersConfig;
};

export type StoredWhitelabelConfig = {
  hasAspirationalOffsetTarget: boolean | undefined;
  minimumReductionPercentage: number | null | undefined;
  step1Answers: WhitelabelStep1AnswersConfig | undefined;
};

const setWhitelabelConfig = (config: WhitelabelConfig) => (dispatch: Dispatch) => {
  const relevantConfig: StoredWhitelabelConfig = {
    minimumReductionPercentage: config?.reducePage?.reductionsConfig.minimumReductionPercentage,
    hasAspirationalOffsetTarget: config?.reducePage?.hasAspirationalOffsetTarget,
    step1Answers: config?.step1Answers,
  };

  dispatch({ type: 'SET_WHITELABEL_CONFIG', config: relevantConfig });
};

export default setWhitelabelConfig;
